"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "tooltip": "tooltip_2hFm-I",
  "tooltip-wrapper": "tooltip-wrapper_Vv5bSa",
  "tooltipWrapper": "tooltip-wrapper_Vv5bSa",
  "tooltip-header": "tooltip-header_2ZQx7e",
  "tooltipHeader": "tooltip-header_2ZQx7e",
  "tooltip-content": "tooltip-content_O77VxE",
  "tooltipContent": "tooltip-content_O77VxE"
}; 
require('./TooltipLabel.css');
var tooltipTheme = {
  "outer": "outer_1MjL_A",
  "tooltip": "tooltip_TQe9Fo",
  "tooltip-position-right": "tooltip-position-right_1j4yCN",
  "tooltipPositionRight": "tooltip-position-right_1j4yCN"
}; 
require('./TooltipTheme.css');
var TooltipLabel = function TooltipLabel(props) {
  var id = props.id,
    label = props.label,
    offset = props.offset,
    position = props.position,
    tooltipContent = props.tooltipContent,
    tooltipHeader = props.tooltipHeader,
    tooltipIcon = props.tooltipIcon,
    children = props.children;
  var contentId = "".concat(id, "-tooltip-content");
  var content = /*#__PURE__*/_react.default.createElement("div", {
    id: contentId,
    className: styles.tooltipWrapper,
    "data-test-id": "tooltip-wrapper"
  }, tooltipHeader ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltipHeader,
    "data-test-id": "tooltip-header"
  }, tooltipHeader) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltipContent,
    "data-test-id": "tooltip-content"
  }, tooltipContent));
  var icon = tooltipIcon || /*#__PURE__*/_react.default.createElement(InfoIcon, null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label ? /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "tooltiplabel-label"
  }, label) : null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    className: (0, _classnames.default)(styles.tooltip, tooltipTheme.outer),
    theme: tooltipTheme,
    position: position,
    offset: offset,
    style: {
      zIndex: 2000
    },
    content: content
  }, children || /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, icon)));
};
TooltipLabel.defaultProps = {
  offset: [0, 0],
  position: 'right'
};
var _default = exports.default = TooltipLabel;
//# sourceMappingURL=TooltipLabel.js.map